var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0.299988C0.172 0.299988 0 1.17399 0 7.99999C0 14.826 0.172 15.7 10 15.7C19.828 15.7 20 14.826 20 7.99999C20 1.17399 19.828 0.299988 10 0.299988ZM13.205 8.33399L8.715 10.43C8.322 10.612 8 10.408 8 9.97399V6.02599C8 5.59299 8.322 5.38799 8.715 5.56999L13.205 7.66599C13.598 7.84999 13.598 8.14999 13.205 8.33399Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
